export interface Promotion {
  id: number;
  type: 'percentage' | 'fixed';
  value: number;
  startDate: string;
  endDate: string;
  label?: string;
}

interface ProductWithPromo {
  promotion?: Promotion;
  price?: string;
  base_price?: string;
}

export function isPromotionActive(product: ProductWithPromo): boolean {
  const promo = product.promotion;
  if (!promo) return false;
  const now = new Date().getTime();
  const start = new Date(promo.startDate).getTime();
  const end = new Date(promo.endDate).getTime();
  return now >= start && now <= end;
}

export function getPromotionName(product: ProductWithPromo): string {
  const promo = product.promotion;
  if (!promo?.label) return 'SALE';
  return promo.label;
}

export function calculateDiscountedPrice(
  originalPrice: number,
  promotion: Promotion
): number {
  if (promotion.type === 'percentage') {
    return originalPrice * (1 - promotion.value / 100);
  }
  return Math.max(0, originalPrice - promotion.value);
}

export function isSpecialPriceActive(product: ProductWithPromo): boolean {
  return isPromotionActive(product);
}
